export const UserRolesEnum = {
    SUPER_ADMIN: 'super_user',
    CHAIN_ADMIN: 'chain_admin',
    REGULAR_USER: 'clinic_user',
}
